export default {
  heading: "Set up Email Forwarding Function",
  userEmail: "EdCity Email Address",
  fromEmail1: "Forward my EdCity email address ",
  fromEmail2: " to:",
  toEmail: " Email address",
  stopEmail: "I wish to disable Email Forwarding Function",
  stopForwardingAlertTitle: "Disable Email Forwarding Function",
  stopForwardingAlert: "After disabling the Email Forwarding Function, you will no longer be able to reactivate the function.",
  retireMsg: "<b><u>Discontinuation of EdCity Email Forwarding Service with effective from 31 January 2027</u></b><p>To ensure that you can continue to receive notifications and other communications from third-party services after the email forwarding service ends, we recommend that you take the following actions:</p><ul class='pl-10'><li>Update your email contact address registered with your third-party service accounts</li><li>Use email address that is managed by yourself for registration  </li></ul><p>If you need an extension of service to make necessary arrangements, please email to <a href='mailto:support{'@'}edcity.hk'>support{'@'}edcity.hk</a> before <b>31 January 2027</b>. Request will be reviewed on a case-by-case basis and do our best to provide appropriate assistance.</p>",
  button: {
    back: "Back",
    stop: "Disable",
  }
};
